import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Madres de bebés entre 4 y 24 meses que despiertan más de 3 veces por noche.', 'Familias que no quieren usar métodos de llanto prolongado pero están al borde del colapso.', 'Mamás latinas en USA o Latam que no cuentan con red de apoyo nocturna.', 'Padres que buscan una solución práctica, biológica y respetuosa con el desarrollo infantil.'];
  const notForWho = ['Personas que buscan una "pastilla mágica" para que el bebé duerma en 1 día sin esfuerzo.', 'Padres con bebés recién nacidos (menores de 4 meses) que aún requieren tomas nocturnas por salud.', 'Quienes prefieren métodos de adiestramiento de sueño tipo "dejar llorar" sin intervención.'];
  return <section className="bg-light-empathy text-text-light py-20 md:py-28 px-6" data-id="element-12">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-13">
        {/* For Who */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-lg border-t-4 border-green-500" data-id="element-14">
          <h2 className="text-2xl md:text-3xl font-serif mb-8 text-dark-100" data-id="element-15">
            Para ti si...
          </h2>
          <ul className="space-y-6" data-id="element-16">
            {forWho.map((item, index) => <li key={index} className="flex items-start space-x-4" data-id="element-17">
                <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-18" />
                <span className="text-lg text-text-light/80" data-id="element-19">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Not For Who */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-white/50 rounded-3xl p-8 md:p-12 border border-red-200" data-id="element-20">
          <h2 className="text-2xl md:text-3xl font-serif mb-8 text-dark-100/70" data-id="element-21">
            No es para ti si...
          </h2>
          <ul className="space-y-6" data-id="element-22">
            {notForWho.map((item, index) => <li key={index} className="flex items-start space-x-4 opacity-70" data-id="element-23">
                <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-24" />
                <span className="text-lg text-text-light/80" data-id="element-25">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}